export const prefix = typeof window === 'undefined' ? process.env.PUBLIC_API : process.env.NEXT_PUBLIC_API;
